import { RuntimeStyle } from "@homebound/truss/runtime";

/**
 * Applying some Blueprint global styles that differ from Beam.
 *
 * (This is old/hacky/terrible, but we're stuck with it?)
 */
export function LocalCssReset() {
  return (
    <RuntimeStyle
      css={{
        html: `
          -webkit-font-smoothing: antialiased;
        `,
        body: `
          margin: 0;
          background-color: rgba(247, 245, 245, 1);
          color: rgba(53, 53, 53, 1);
          font-size: 14px;
          line-height: 20px;
      `,
      }}
    />
  );
}
